import { useMemo, useCallback, memo } from 'react';

import { useCalendarContext } from './Calendar.utils';
import { Select } from '../Select';

const MonthDropdownBase = ({ className }: { className?: string }) => {
  const state = useCalendarContext();

  // Format the name of each month in the year according to the
  // current locale and calendar system. Note that in some calendar
  // systems, such as the Hebrew, the number of months may differ
  // between years.
  const monthOptions = useMemo(() => {
    const numMonths = state.focusedDate.calendar.getMonthsInYear(state.focusedDate);

    return Array.from({ length: numMonths }, (_, monthIndex) => {
      const date = state.focusedDate.set({ month: monthIndex + 1 });
      return {
        value: monthIndex + 1,
        label: date.toDate(state.timeZone).toLocaleDateString('en-US', { month: 'short' }),
      };
    });
  }, [state]);

  const handleSelectionChange = useCallback(
    (value: number | null | undefined) => {
      if (!value) return;

      state.setFocusedDate(state.focusedDate.set({ month: value }));
    },
    [state],
  );

  return (
    <Select
      options={monthOptions}
      value={state.focusedDate.month}
      menuClassName="max-h-[240px]"
      className={className}
      onValueChange={handleSelectionChange}
      placeholder="Month"
      variant="simple"
      autoFocusItem
    />
  );
};

export const MonthDropdown = memo(MonthDropdownBase);
